(function ($) {
    $.fn.formFilter = function () {
        var $globalWrapper = $(this);

        var SHOW_BUTTON_ACTIVE_CLASS = 'active';
        var ENTRY_LIMIT = parseInt($globalWrapper.data('limit'));
        var totalProjects = parseInt($globalWrapper.data('total-count'));
        var $form = $globalWrapper.find('.js-form-filter');
        var url = $form.attr('action');
        var method = $form.attr('method');
        var $formInput = $form.find('.js-form-filter-input');
        var $category = $form.find('.js-form-filter-category');
        var $valueListItem = $form.find('.js-form-filter-find-element');
        var $buttonReset = $form.find('.js-form-filter-reset');
        var $filterWrapper = $globalWrapper.find('.js-form-filter-wrapper');
        var $projectListWrapper = $globalWrapper.find('.js-project-list');
        var $showMoreButton = $globalWrapper.find('.js-form-filter-load');
        var $inputFindNames = $form.find('.js-form-filter-filter-input-names');
        var filterValue = {};
        var offsetValue = 0;
        var sendData;

        /**
         * Заполнение input
         * удаляется поле если выбрано "не выбрано"
         */

        var fillFilterValue = function () {
            $formInput.each(function () {
                var nameInput = $(this).attr('name');
                var valueInput = $(this).val();
                if (valueInput === '') {
                    return;
                }
                if (valueInput === 'null') {
                    delete filterValue[nameInput];
                    return;
                }
                filterValue[nameInput] = valueInput;
            });
        };
        /**
         * сброс фильтров
         */
        var resetsFilters= function () {
            $formInput.val('');
            filterValue = {};
            $category.each(function () {
                $(this).find('.js-form-filter-title').text($(this).find('.js-form-filter-find-element').eq(0).text())
            });
            ajaxSend();
            toggleClassFilterReset();
        };
        /**
         * показываем/прячем кнопку сброса
         */
        var toggleClassFilterReset = function () {
            if($buttonReset) {
                $buttonReset.toggleClass('covert');
            }
        }
        /**
         * Открытие списка
         */
        var openListFunction = function () {
            $category.each(function () {
                $(this).on('click', function () {
                    toggleActiveClass($(this));
                });
            });
        };
        /**
         * убирает у всех $category активный класс и добавляет переданному $category активный класс
         */
        var toggleActiveClass = function (element) {
            if(element.hasClass('active')) {
                element.removeClass('active');
                return;
            }
            $category.each(function () {
                $(this).removeClass('active');
            });
            element.addClass('active');
        };

        /**
         * поиск по имени
         */
        var findForNames = function () {
            $inputFindNames.on('input', function () {
                sendRequest(true);
                if (!$buttonReset.hasClass('covert')) {
                    return;
                }

                toggleClassFilterReset();
            });
        };
        /**
         * меняем Заголовки и заполняем input
         */
        var fillCategoryTitle = function () {
            $valueListItem.each(function () {
                $(this).on('click', function (evt) {
                    evt.preventDefault();
                    var title = $(this).closest('.js-form-filter-category').find('.js-form-filter-title');
                    var input = $(this).closest('.js-form-filter-category').find('.js-form-filter-input');
                    var text = $(this).text();
                    var id = $(this).attr('data-value');
                    title.text(text);
                    input.val(id);

                    sendRequest(true);

                    if (!$buttonReset.hasClass('covert')) {
                        return;
                    }

                    toggleClassFilterReset();
                });
            });
        };


        /**
         * выключение кнопки 'показать еще'
         */
        var hideButtonShowMore = function () {
            $showMoreButton.removeClass(SHOW_BUTTON_ACTIVE_CLASS);
        };

        var getCurrentShowProjects = function () {
            return $filterWrapper.find('.js-project-item').length;
        }

        /**
         * Инициализация кнопки "показать еще"
         * вещаем обработчик на кнопку дозагрузки проектов
         */
        var showButtonShowMore = function () {
            var currentProjectsLength = getCurrentShowProjects();

            if (currentProjectsLength >= totalProjects) {
                return;
            }

            $showMoreButton.addClass(SHOW_BUTTON_ACTIVE_CLASS);
        };

        /**
         * ajax-функция
         */
        var ajaxSend = function (reset ) {
            reset = typeof reset === 'undefined' ? true : false;

            if (reset) {
                offsetValue = 0;
            }

            sendData = {
                filter: filterValue,
                limit: ENTRY_LIMIT,
                offset: offsetValue,
            };
            $.ajax({
                url : url,
                data: sendData,
                type: method
            }).done(function(data) {
                if (data) {
                    if (reset) {
                        $projectListWrapper.empty();
                    }

                    totalProjects = data.totalCount;

                    $projectListWrapper.append(data.html);

                    offsetValue = getCurrentShowProjects();

                    // Если текущее смещение больше колличества проектов, скрываем кнопку
                    if (offsetValue >= totalProjects) {
                        hideButtonShowMore();
                    } else {
                        showButtonShowMore();
                    }
                }
            });
        }

        /**
         * загрузка списка проектов по фильтру
         */
        var sendRequest = function () {
            fillFilterValue();
            $form.trigger('submit');
        };

        var initEvents = function () {
            $globalWrapper.on('click', '.js-form-filter-load', function () {
                ajaxSend(false);
            });

            $form.on('submit', function (evt) {
                evt.preventDefault();
                ajaxSend();
            });

            $buttonReset.on('click', function () {
                resetsFilters();
            });
        }

        /**
         * Инициализация
         * вешается обработчик на кнопку поиска
         */
        var init = function () {
            initEvents();
            offsetValue = getCurrentShowProjects();
            showButtonShowMore();
            openListFunction();
            fillCategoryTitle();
            findForNames();
        };

        init();
    };

    $('.js-project-filters-with-form').each(function () {
        $(this).data('formFilterProjects', $(this).formFilter());
    });
})(jQuery);
